export const msToTime = (duration) => {
  let
    seconds = Math.floor((duration / 1000) % 60);
  let minutes = Math.floor((duration / (1000 * 60)) % 60);
  let hours = Math.floor((duration / (1000 * 60 * 60)) % 24);

  hours = (hours < 10) ? `0${hours}` : hours;
  minutes = (minutes < 10) ? `0${minutes}` : minutes;
  seconds = (seconds < 10) ? `0${seconds}` : seconds;
  return hours === '00' ? `${minutes}:${seconds}` : `${hours}:${minutes}:${seconds}`;
};

export const INTEGRATION_TYPE = {
  TOOLS: 'TOOLS',
  THIRD_PARTY: 'TP',
}

export const EXPECTED_SALES_OPTIONS = [
  {
    label: '₹0 - ₹10000',
    value: '10000',
  },
  {
    value: '30000',
    label: '₹10001 - ₹30000',
  },
  {
    value: '60000',
    label: '₹30001 - ₹60000',
  },
  {
    value: '80000',
    label: '₹60001 - ₹80000',
  },
  {
    value: '120000',
    label: '₹80001 - ₹120000',
  },
  {
    value: '150000',
    label: '₹120001 - ₹150000',
  },
  {
    value: '300000',
    label: '₹150001 - ₹300000',
  },
  {
    value: '500000',
    label: '₹300001 - ₹500000',
  },
  {
    value: '500001',
    label: '₹500001 and more',
  },
];